<script setup lang="ts">
import { Inbox, FileQuestion, SearchX } from '@lucide/vue'

const props = withDefaults(
  defineProps<{
    title?: string
    description?: string
    image?: 'default' | 'search' | '404'
    compact?: boolean
  }>(),
  {
    title: '暂无数据',
    description: '',
    image: 'default',
    compact: false
  }
)
</script>

<template>
  <div class="rr-empty" :class="{ 'is-compact': compact }">
    <div class="rr-empty__image">
      <slot name="image">
        <SearchX v-if="image === 'search'" :size="compact ? 24 : 36" :stroke-width="1.5" />
        <FileQuestion v-else-if="image === '404'" :size="compact ? 24 : 36" :stroke-width="1.5" />
        <Inbox v-else :size="compact ? 24 : 36" :stroke-width="1.5" />
      </slot>
    </div>
    <div class="rr-empty__content">
      <strong class="rr-empty__title">{{ title }}</strong>
      <p v-if="description" class="rr-empty__description">{{ description }}</p>
      <slot />
    </div>
    <div v-if="$slots.actions" class="rr-empty__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<style scoped>
.rr-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 24px 16px;
  text-align: center;
  box-sizing: border-box;
}

.rr-empty.is-compact {
  min-height: 90px;
  padding: 12px;
}

.rr-empty__image {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  color: var(--rr-color-text-subtle);
  opacity: 0.8;
}

.rr-empty__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.rr-empty__title {
  color: var(--rr-color-text);
  font-size: 13px;
  font-weight: 600;
}

.rr-empty__description {
  margin: 0;
  max-width: 48ch;
  color: var(--rr-color-text-muted);
  font-size: 12px;
  line-height: 1.5;
}

.rr-empty__actions {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
